/**
 * Shape-only validation of a public communication token.
 *
 * This is deliberately NOT crypto validation: the SPA never decrypts or
 * verifies the AES-256 token (that stays server-side in OPINK, US-2.2). All we
 * do here is reject obviously malformed input (wrong length / illegal chars)
 * so the view can fall through to the generic ErrorView WITHOUT ever leaking
 * whether a contact exists.
 *
 * Accepts URL-safe base64 (A–Z a–z 0–9 - _) of at least 16 chars.
 */
const TOKEN_PATTERN = /^[A-Za-z0-9_-]{16,512}$/;
export function isShapeValidToken(token) {
    if (typeof token !== "string") {
        return false;
    }
    return TOKEN_PATTERN.test(token);
}
